
    export default 
    {
    "impotList": {
        "title": "Liste importieren"
    }
}